import { render, staticRenderFns } from "./LiveGroup.vue?vue&type=template&id=78a52a3a&scoped=true"
import script from "./LiveGroup.vue?vue&type=script&lang=js"
export * from "./LiveGroup.vue?vue&type=script&lang=js"
import style0 from "./LiveGroup.vue?vue&type=style&index=0&id=78a52a3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a52a3a",
  null
  
)

export default component.exports